import { render } from "./RequestToReceive.vue?vue&type=template&id=bcff6c70"
import script from "./RequestToReceive.vue?vue&type=script&lang=js"
export * from "./RequestToReceive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__